import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SapRequestService {
  api = environment.api;

  constructor( private http: HttpClient ) { }

  getRequest(filters) {
    return this.http.get(this.api+`/ordem-servico/requisicoes-sap/${filters}`);
  }
}
